import * as Types from '../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CreateOrgAdminMutationVariables = Types.Exact<{
  input: Types.CreateOrgAdminInput
}>

export type CreateOrgAdminMutation = {
  __typename?: 'Mutation'
  createOrgAdmin?: {
    __typename?: 'CreateOrgAdminPayload'
    user?: {
      __typename?: 'User'
      id: number
      roles: Array<{ __typename?: 'Role'; label?: string | null }>
    } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CreateOrgAdminDocument = `
    mutation CreateOrgAdmin($input: CreateOrgAdminInput!) {
  createOrgAdmin(input: $input) {
    user {
      id
      roles(roleType: OrganizationRole) {
        label
      }
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useCreateOrgAdminMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<CreateOrgAdminMutation, TError, CreateOrgAdminMutationVariables, TContext>
) =>
  useMutation<CreateOrgAdminMutation, TError, CreateOrgAdminMutationVariables, TContext>(
    ['CreateOrgAdmin'],
    (variables?: CreateOrgAdminMutationVariables) =>
      fetchGql<CreateOrgAdminMutation, CreateOrgAdminMutationVariables>(CreateOrgAdminDocument, variables)(),
    options
  )
